import BaseTable from "./BaseTable"

export default BaseTable;